// extracted by mini-css-extract-plugin
module.exports = {"tabActive":"MyData_tabActive__1ifOi"};